import React, { createContext, useCallback, useContext, useState } from "react";
import { axiosNSInsance } from "../utils/axios";

const InventoryContext = createContext({
  discounts: [],
  registered: false,
});

export const useInventoryContext = () => {
  return useContext(InventoryContext);
};

export const InventoryProvider = ({ children }) => {
  const [items, setItems] = useState({
    discounts: [],
    registered: false,
  });

  const loadProfileItems = useCallback(async (season) => {
    const discordId = localStorage.getItem("discordId");
    const response = await axiosNSInsance.post(`/items`, {
      discordId,
    });
    if (response) setItems(response.data);
  }, []);

  return (
    <InventoryContext.Provider
      value={{
        discounts: items.discounts || [],
        registered: items.registered || false,
        loadProfileItems,
      }}
    >
      {children}
    </InventoryContext.Provider>
  );
};
